// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SeoLandingIndexPage-module__wrapper","heading":"SeoLandingIndexPage-module__heading","list":"SeoLandingIndexPage-module__list"};